import React, { useState } from "react";
import { Col, Row, Button, Input } from "reactstrap";
import { CanvasComponent } from '../../../canvas/CanvasComponent';
import { Card } from 'primereact/card';
import { AlertDataTable } from '../../../../components/tableDataTable/AlertDataTable';




export const ComponentInformedSurvey = (props) => {
    const {
        items,
        onSelectOption,
        onInputChange,
        onBack,
        handleAyuno,
        selectedHour,
        setSelectedHour,
        difHourBrakfast,
        difMinuteBrakfast,
        calculateAyuno,
        setInformedConsent,
        canvasRef,
        handleChange,
        iniImg,
        handleFinish,
        repeatFirm

    } = props;

    const buttonStyle = (selected) => ({
        borderRadius: "12px",
        padding: "10px 18px",
        backgroundColor: selected ? "#002940" : "#ffffff",
        color: selected ? "#ffffff" : "#002940",
        border: `2px solid ${selected ? "#002940" : "#c2dce8"}`,
        fontWeight: "600",
        fontSize: "15px",
        cursor: "pointer",
        boxShadow: selected ? "0 3px 8px rgba(0,0,0,0.15)" : "0 2px 4px rgba(0,0,0,0.05)",
        transition: "all 0.25s ease"
    });



    const buttonStyleAccept = (selected) => ({
        borderRadius: "15px",
        backgroundColor: selected ? "#f97316" : "white",
        color: selected ? "white" : "#f97316",
        border: `2px solid ${selected ? "#f97316" : "#006d97"}`,
        width: "150px",
        height: "35px",
        marginBottom: "10px",
        cursor: "pointer",
        textAlign: "center"
    });


    const [modalAlert, setModalAlert] = useState(false);

    const toggleAlert = () => {
        setModalAlert(!modalAlert);
    };




    return (
        <Card className="pt-0 shadow-sm"
            style={{
                borderRadius: "16px",
                border: "1px solid #dcdcdc",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                padding: "25px 20px",
            }} >
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <h3 style={{ margin: 0, color: "#00364d", fontWeight: "600" }}>
                    Carta de Consentimiento Informado
                </h3>
                <div style={{
                    width: "80px",
                    height: "4px",
                    background: "#f97316",
                    margin: "10px auto 0 auto",
                    borderRadius: "2px"
                }} />
            </div>

            <div style={{
                marginBottom: "2rem",
                padding: "1.5rem",

            }}
                className="pb-4"
            >
                {items.map(
                    (q, qi) =>
                        q.visibility && (
                            <div key={q.id_satisfaction_question} style={{ marginBottom: "10px" }}>
                                {
                                    // ? TITLE QUESTION
                                }
                                <Row>
                                    <Col sm="2" className="pb-1" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        {qi > 0 && (
                                            <div
                                                onClick={() => onBack(qi)}
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#f97316",
                                                    color: "#fff",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    fontWeight: "bold",
                                                    fontSize: "18px",
                                                    cursor: "pointer",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                    transition: "transform 0.2s",
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.1)"}
                                                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                                                title="Pregunta anterior"
                                            >
                                                ←
                                            </div>
                                        )}

                                        <div
                                            style={{
                                                minWidth: "70px",
                                                padding: "8px 12px",
                                                borderRadius: "12px",
                                                background: qi === items.findIndex(item => item.visibility)
                                                    ? "linear-gradient(135deg, #006d97, #00b4db)"
                                                    : "#ffffff",
                                                color: qi === items.findIndex(item => item.visibility) ? "#fff" : "#006d97",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                textAlign: "center",
                                                boxShadow: qi === items.findIndex(item => item.visibility) ? "0 4px 6px rgba(0,0,0,0.1)" : "0 1px 2px rgba(0,0,0,0.05)",
                                                transition: "all 0.2s",
                                                cursor: "default",
                                            }}
                                            title={`Pregunta ${qi + 1} de ${items.length}`}
                                            onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                                            onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                                        >
                                            {qi + 1} / {items.length}
                                        </div>
                                    </Col>



                                    <Col sm="12"  >
                                        <h4 style={{ marginBottom: "15px" }}>{q.question}</h4>

                                    </Col>
                                </Row>
                                {
                                    // ? TYPE 1 — ABIERTA
                                }

                                {
                                    q.type === 1 &&
                                    (() => {

                                        const hasTimeField =
                                            Array.isArray(q.listReagents) &&
                                            q.listReagents.length > 0 &&
                                            q.listReagents.some((r) => r.reagent === "Fecha/Hora");

                                        if (hasTimeField && q.listReagents.length >= 0) {

                                            const horaValida =
                                                q.listReagents[0].numeric_value &&
                                                q.listReagents[0].numeric_value !== "No Aplica";

                                            return (
                                                <Row className="pt-4" key={q.id_satisfaction_question}>
                                                    <Col sm="12">
                                                        <Row>
                                                            <Col sm="3" style={{ textAlignLast: "center" }}>
                                                                <input
                                                                    type="time"
                                                                    value={horaValida ? q.listReagents[0].numeric_value : selectedHour || ""}
                                                                    onChange={(e) => {
                                                                        const updated = [...items];
                                                                        updated[qi].listReagents[0].numeric_value = e.target.value;

                                                                        if (updated[qi].listReagents[1]) {
                                                                            updated[qi].listReagents[1].selected_response = false;
                                                                        }

                                                                        setInformedConsent(updated);
                                                                        setSelectedHour(e.target.value);
                                                                        calculateAyuno(e.target.value);
                                                                    }}
                                                                    style={{
                                                                        width: "200px",
                                                                        height: "50px",
                                                                        padding: "6px 12px",
                                                                        borderRadius: "10px",
                                                                        border: "2px solid #c2dce8",
                                                                        background: "#f9fcff",
                                                                        fontSize: "18px",
                                                                        color: "#00364d",
                                                                        outline: "none",
                                                                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                                                        transition: "all 0.3s",
                                                                    }}
                                                                />
                                                            </Col>

                                                            <Col sm="8" className="mr-4 ">
                                                                {horaValida && (
                                                                    <button
                                                                        onClick={() => handleAyuno(qi, q.listReagents[0].numeric_value)}
                                                                        style={{ ...buttonStyle(true), marginRight: "10px" }}
                                                                    >
                                                                        {`Ayuno de ${difHourBrakfast}:${difMinuteBrakfast}`}
                                                                    </button>
                                                                )}

                                                                <button
                                                                    onClick={() => {
                                                                        const updated = [...items];

                                                                        if (!updated[qi].listReagents[1]) return;

                                                                        updated[qi].listReagents[1].selected_response = true;
                                                                        updated[qi].listReagents[0].numeric_value = "No Aplica";
                                                                        updated[qi].visibility = false;

                                                                        if (updated[qi + 1]) updated[qi + 1].visibility = true;

                                                                        setInformedConsent(updated);
                                                                    }}
                                                                    style={buttonStyle(q.listReagents[1]?.selected_response)}
                                                                >
                                                                    No Aplica
                                                                </button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            );
                                        }

                                        return (
                                            <div style={{ width: "100%" }}>
                                                <Input
                                                    type="textarea"
                                                    value={q.answer || ""}
                                                    onChange={(e) => onInputChange(qi, e.target.value)}
                                                    style={{
                                                        borderRadius: "12px",
                                                        border: "1px solid #006d97",
                                                        backgroundColor: "#f9f9f9",
                                                        color: "#333",
                                                        minHeight: "100px",
                                                        padding: "12px 15px",
                                                        fontSize: "16px",
                                                        fontFamily: "Arial, sans-serif",
                                                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                                        transition: "all 0.3s ease",
                                                        outline: "none",
                                                        width: "100%",
                                                    }}
                                                />
                                                <br />

                                                <button
                                                    style={buttonStyleAccept(...items)}
                                                    disabled={!q.answer || q.answer.trim() === ""}
                                                    onClick={() => {
                                                        const updated = [...items];

                                                        updated[qi].visibility = false;
                                                        if (updated[qi + 1]) updated[qi + 1].visibility = true;

                                                        setInformedConsent(updated);
                                                    }}
                                                >
                                                    Continuar
                                                </button>
                                            </div>
                                        );
                                    })()
                                }
                                {
                                    // ? TYPE 2 — OPCIÓN CERRADA
                                }
                                {
                                    q.type === 2 && (
                                        <Row className="pt-4">
                                            {q.listReagents.map((r, ri) => (
                                                <Col
                                                    key={ri}

                                                    sm={12 / q.listReagents.length}

                                                    style={{ marginBottom: "10px" }}
                                                >
                                                    <button
                                                        style={buttonStyle(r.selected_response)}
                                                        onClick={() => {
                                                            if (r.sub_nivel) {
                                                                const updated = [...items];
                                                                updated[qi].listReagents.forEach((rep, i) => {
                                                                    rep.selected_response = i === ri;
                                                                });
                                                                setInformedConsent(updated);
                                                            } else {
                                                                onSelectOption(qi, ri);
                                                            }
                                                        }}
                                                    >
                                                        {r.reagent}
                                                    </button>

                                                    {r.sub_nivel && r.selected_response && r.alternativeQuestionsInformed.length > 0 && (
                                                        <div style={{ marginTop: "10px" }}>
                                                            {r.alternativeQuestionsInformed.map((sub, si) => (
                                                                <div key={sub.id_alternative_question} style={{ marginTop: "5px" }}>
                                                                    <label>{sub.alternative_question}</label>

                                                                    <Input
                                                                        type="textarea"
                                                                        value={sub.comments || ""}
                                                                        onChange={(e) => onInputChange(qi, e.target.value, ri, si)}
                                                                        style={{
                                                                            borderRadius: "12px",
                                                                            border: "1px solid #006d97",
                                                                            backgroundColor: "#f9f9f9",
                                                                            color: "#333",
                                                                            minHeight: "100px",
                                                                            padding: "12px 15px",
                                                                            fontSize: "16px",
                                                                            fontFamily: "Arial, sans-serif",
                                                                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                                                            transition: "all 0.3s ease",
                                                                            outline: "none",
                                                                        }}
                                                                        onFocus={(e) => {
                                                                            e.target.style.border = "2px solid #006d97";
                                                                            e.target.style.boxShadow =
                                                                                "0 4px 12px rgba(0, 109, 151, 0.2)";
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            e.target.style.border = "1px solid #006d97";
                                                                            e.target.style.boxShadow =
                                                                                "0 4px 8px rgba(0,0,0,0.1)";
                                                                        }}
                                                                    />
                                                                    <br />

                                                                    <button
                                                                        style={buttonStyleAccept(r.selected_response)}
                                                                        onClick={() => {
                                                                            const subQuestion = r.alternativeQuestionsInformed[si];

                                                                            if (!subQuestion.comments || subQuestion.comments.trim() === "") {
                                                                                toggleAlert();
                                                                                return;
                                                                            }

                                                                            onSelectOption(qi, ri, true);
                                                                        }}
                                                                    >
                                                                        Continuar
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </Col>
                                            ))}
                                        </Row>
                                    )
                                }

                                {
                                    // ? TYPE 3 — MULTIPLE REAGENTS
                                }
                                {
                                    q.type === 3 && (
                                        <Row className="pt-4">
                                            {q.listReagents.map((r, ri) => (
                                                <Col sm="6" key={ri}>
                                                    <Button
                                                        block
                                                        color={r.selected_response ? "primary" : "success"}
                                                        onClick={() => onSelectOption(qi, ri)}
                                                    >
                                                        {r.reagent}
                                                    </Button>
                                                </Col>
                                            ))}
                                        </Row>
                                    )
                                }
                                {
                                    // ? TYPE 4 — FIRMA
                                }
                                {
                                    q.type === 4 && (<>
                                        <CanvasComponent
                                            canvasRef={canvasRef}
                                            handleChange={handleChange}
                                            width={1190}
                                            height={200}
                                            brushColor={"#000"}
                                            brushRadius={1}
                                            lazyRadius={3}
                                            previousImage={iniImg}
                                        />
                                        <Col sm="12" className="pt-3" style={{ textAlign: "center" }} >
                                            <h5 htmlFor="txt-center">Firma del Paciente / Tutor Legal</h5>
                                        </Col>
                                    </>
                                    )
                                }
                                {
                                    // ? TYPE 5 — TEXT AREA CON BOTONES
                                }
                                {
                                    q.type === 5 && (
                                        <div style={{ marginTop: "10px" }} className="pt-3">
                                            <Col sm="12">
                                                <Row>
                                                    <Col sm="6" className="p-l-0" >
                                                        <Input
                                                            type="textarea"
                                                            value={q.answer || ""}
                                                            onChange={(e) => onInputChange(qi, e.target.value)}
                                                            style={{
                                                                borderRadius: "12px",
                                                                border: "1px solid #006d97",
                                                                backgroundColor: "#f9f9f9",
                                                                color: "#333",
                                                                minHeight: "100px",
                                                                padding: "12px 15px",
                                                                fontSize: "16px",
                                                                fontFamily: "Arial, sans-serif",
                                                                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                                                transition: "all 0.3s ease",
                                                                outline: "none",
                                                            }}
                                                            onFocus={(e) => {
                                                                e.target.style.border = "2px solid #006d97";
                                                                e.target.style.boxShadow = "0 4px 12px rgba(0, 109, 151, 0.2)";
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.border = "1px solid #006d97";
                                                                e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                                                            }}
                                                        />
                                                        <div className="pt-3" >
                                                            <button
                                                                style={buttonStyleAccept(...items)}
                                                                onClick={() => {
                                                                    const updated = [...items];
                                                                    if (updated[qi].answer && updated[qi + 1]) {
                                                                        updated[qi].visibility = false;
                                                                        updated[qi + 1].visibility = true;
                                                                        setInformedConsent(updated);
                                                                    }
                                                                }}
                                                            >
                                                                Continuar
                                                            </button>
                                                        </div>
                                                    </Col>
                                                    <Col sm="4" className="pt-5" >
                                                        {q.listReagents?.length > 0 && (
                                                            <button
                                                                style={buttonStyle(q.listReagents[0]?.selected_response)}

                                                                onClick={() => {
                                                                    const updated = [...items];

                                                                    updated[qi].listReagents[0].selected_response = true;

                                                                    updated[qi].answer = "";

                                                                    if (updated[qi + 1]) {
                                                                        updated[qi].visibility = false;
                                                                        updated[qi + 1].visibility = true;
                                                                    }

                                                                    setInformedConsent(updated);
                                                                }}
                                                            >
                                                                No Aplica
                                                            </button>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </div>
                                    )
                                }
                                {
                                    // ? TYPE 6
                                }
                                {q.type === 6 && (
                                    <div style={{ textAlign: "center", marginTop: "40px" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: "40px",
                                                flexWrap: "wrap",
                                                marginTop: "30px",
                                            }}
                                        >
                                            {q.listReagents.map((r, ri) => (
                                                <button
                                                    key={ri}
                                                    onClick={() => {
                                                        const updated = [...items];
                                                        updated[qi].listReagents[ri].selected_response =
                                                            !updated[qi].listReagents[ri].selected_response;
                                                        setInformedConsent(updated);
                                                    }}
                                                    style={buttonStyleAccept(r.selected_response)}
                                                >
                                                    {r.reagent}
                                                </button>
                                            ))}
                                        </div>

                                        {q.listReagents.some((r) => r.selected_response) && (
                                            <button
                                                onClick={() => {
                                                    const updated = [...items];
                                                    updated[qi].visibility = false;
                                                    if (updated[qi + 1]) updated[qi + 1].visibility = true;
                                                    setInformedConsent(updated);
                                                }}
                                                style={{
                                                    marginTop: "30px",
                                                    ...buttonStyleAccept(true),
                                                }}
                                            >
                                                Continuar
                                            </button>
                                        )}
                                    </div>
                                )
                                }

                                {
                                    // ? BUTTON FINISH
                                }
                                {qi === items.length - 1 && (
                                    <div className="text-center mt-4">
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: "20px",
                                                flexWrap: "wrap",
                                                marginTop: "20px"
                                            }}
                                        >
                                            <button
                                                className={q.type === 4 ? "" : "d-none"}
                                                style={{
                                                    width: "280px",

                                                    padding: "12px 24px",
                                                    borderRadius: "14px",
                                                    background: "linear-gradient(135deg, #8ecae6, #8ecae6)",
                                                    color: "white",
                                                    fontSize: "18px",
                                                    fontWeight: "600",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                                    transition: "transform 0.2s"
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.03)"}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                onClick={() => repeatFirm(canvasRef)}
                                            >
                                                Repetir Firma
                                            </button>

                                            <button
                                                style={{
                                                    width: "310px",
                                                    padding: "12px 24px",
                                                    borderRadius: "14px",
                                                    background: "linear-gradient(135deg, #fb8500 , #fb8500 )",
                                                    color: "white",
                                                    fontSize: "18px",
                                                    fontWeight: "600",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                                    transition: "transform 0.2s"
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.03)"}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                onClick={() => handleFinish()}
                                            >
                                                <i className="pi pi-check" style={{ marginRight: "8px" }}></i>
                                                Finalizar consentimiento
                                            </button>
                                        </div>
                                    </div>
                                )}

                            </div>
                        )
                )}
            </div>
            {
                modalAlert && (
                    <AlertDataTable
                        titleAlert="Consentimiento Informado"
                        visibleAlert={modalAlert}
                        onHideAlert={toggleAlert}
                        titleNotLoading="Aceptar"
                        titleDanger="Regresar"
                        messageAlert="No se puede continuar con la siguiente pregunta."
                        alert1={false}
                        titleAlert1="Debe de colocar una observación  "
                    />
                )
            }
        </Card >

    );
};